import { render, staticRenderFns } from "./Faqs_edit.vue?vue&type=template&id=2ef3011d&scoped=true&"
import script from "./Faqs_edit.vue?vue&type=script&lang=js&"
export * from "./Faqs_edit.vue?vue&type=script&lang=js&"
import style0 from "./Faqs_edit.vue?vue&type=style&index=0&id=2ef3011d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3011d",
  null
  
)

export default component.exports